import { render, staticRenderFns } from "./ProformaContractDataHeader.vue?vue&type=template&id=56d2a8c2&scoped=true&lang=pug&"
import script from "./ProformaContractDataHeader.vue?vue&type=script&lang=ts&"
export * from "./ProformaContractDataHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ProformaContractDataHeader.vue?vue&type=style&index=0&id=56d2a8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d2a8c2",
  null
  
)

export default component.exports